/* eslint-disable no-unused-vars */
import { CardContent, Grid } from "@mui/material";
import { makeStyles, propsToClassKey } from "@mui/styles";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import Shipping from "@mui/icons-material/LocalShipping";
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle";
import Card from "../../components/Card/Card.js";
import CardFooter from "../../components/Card/CardFooter.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
// core components
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import PurchaseAndSaleByDept from "./PurchaseAndSalesByDept";
import StockDeptWise from "./StockDeptWise";
import SalesDeptWise from "./SalesDeptWise";
import SalesTreand from "./SalesTreand";
import TerminalInfo from "./Terminalnfo";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [noPurchaseOrders, setNoPurchaseOrders] = useState(0);
  const [noInvoices, setNoInvoices] = useState(0);

  const [dashboardSetting, setDashBoardSetting] = useState({});

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    const result = await API.get("/api/v1/dashboard/summary");
    console.log(result.data.noProducts);
    setNoInvoices(result.data.dailySales);
    setNoPurchaseOrders(result.data.dailyPurchase);

    const { data } = await API.get("/api/v1/setting/dashboard");
    setDashBoardSetting(data);
  }

  return (
    <div>
      <Grid container spacing={"5px"} style={{ marginTop: "10px" }}>
        {props.context.privileges.dashboard_shop_info && (
          <Grid item xs={12} md={6} xl={6}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <HomeWorkIcon></HomeWorkIcon>
                </CardIcon>
                <p className={classes.cardCategory}>{"Shop"}</p>
                <h3 className={classes.cardTitle}>
                  {localStorage.getItem("storeName")
                    ? localStorage.getItem("storeName")
                    : ""}
                </h3>
              </CardHeader>
              <CardFooter stats>
                {/*
                <div className={classes.stats}>
                  <LocalOffer />
                  <a href="#pablo" onClick={(e) => e.preventDefault()}></a>
                </div>
              */}
              </CardFooter>
            </Card>
          </Grid>
        )}
        {props.context.privileges.dashboard_daily_sales && (
          <Grid item xs={12} md={6} xl={6}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <ShoppingCart></ShoppingCart>
                </CardIcon>
                <p className={classes.cardCategory}>
                  {translate("Daily Sales")}
                </p>
                <h3 className={classes.cardTitle}>{noInvoices}</h3>
              </CardHeader>
              <CardFooter stats>
                {/*              <div className={classes.stats}>
                <DateRange />
                See Pending Orders
  </div>*/}
              </CardFooter>
            </Card>
          </Grid>
        )}
        {dashboardSetting.showLast10DaysInvoice &&
          props.context.privileges.dashboard_last_10_days_invoice && (
            <Grid item xs={12} md={12} xl={12}>
              <Card>
                <CardContent>
                  <SalesTreand></SalesTreand>
                </CardContent>
              </Card>
            </Grid>
          )}
        {dashboardSetting.showSaleByDept &&
          props.context.privileges.dashboard_sale_by_dept && (
            <Grid item xs={12} md={6} xl={6}>
              <Card>
                <CardContent>
                  <SalesDeptWise></SalesDeptWise>
                </CardContent>
              </Card>
            </Grid>
          )}
        {dashboardSetting.showSalePurchaseByDept &&
          props.context.privileges.dashboard_purchase_dept && (
            <Grid item xs={12} md={6} xl={6}>
              <Card variant="outlined">
                <CardContent>
                  <PurchaseAndSaleByDept></PurchaseAndSaleByDept>
                </CardContent>
              </Card>
            </Grid>
          )}
        {dashboardSetting.showStockByDept && (
          <Grid item xs={12} md={6} xl={6}>
            <Card>
              <CardContent>
                <StockDeptWise></StockDeptWise>
              </CardContent>
            </Card>
          </Grid>
        )}
        {props.context.privileges.dashboard_terminal_info && (
          <Grid item xs={12} md={6} xl={6}>
            <Card variant="outlined">
              <CardContent>
                <TerminalInfo></TerminalInfo>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
